/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationPartialUpdate
 */
export interface NotificationPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof NotificationPartialUpdate
     */
    topic?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationPartialUpdate
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationPartialUpdate
     */
    user?: number | null;
}

export function NotificationPartialUpdateFromJSON(json: any): NotificationPartialUpdate {
    return NotificationPartialUpdateFromJSONTyped(json, false);
}

export function NotificationPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'topic': !exists(json, 'topic') ? undefined : json['topic'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function NotificationPartialUpdateToJSON(value?: NotificationPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'topic': value.topic,
        'type': value.type,
        'user': value.user,
    };
}


